module.exports = __webpack_public_path__ + "assets/assets/images/icons/icon-video.6f79c0c9.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/icon-video.svg
// module id = 339
// module chunks = 2